import { useRouter } from 'next/router';
import * as React from 'react';

import { EventAttendancePage } from '@/components/admin/events/SimpleEventAttendancePage/components/EventAttendancePage';

import { GroupSimpleEventTabsLayout } from '../layouts/GroupSimpleEventTabsLayout';

export const GroupSimpleEventAttendancePage: React.FC = (props) => {
  const router = useRouter();
  const eventId = router.query.eventId.toString();
  const groupId = router.query.groupId.toString();

  return (
    <GroupSimpleEventTabsLayout eventId={eventId} groupId={groupId}>
      <EventAttendancePage eventId={eventId} />
    </GroupSimpleEventTabsLayout>
  );
};
